import { Injectable } from '@angular/core';
import { Router } from '@angular/router'
import { ToasterService } from 'angular2-toaster';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import * as CryptoJS from 'crypto-js';

const company_setup:any=localStorage.getItem('MINUTES_UNITL_AUTO_LOGOUT')?localStorage.getItem('MINUTES_UNITL_AUTO_LOGOUT'):10;
const MINUTES_UNITL_AUTO_LOGOUT =parseFloat(company_setup)?parseFloat(company_setup): 10 // in mins
const CHECK_INTERVAL = 15000 // in ms
const STORE_KEY = 'lastAction';
const after_logout_redirect_to_specific_url = localStorage.getItem('after_logout_redirect_to_specific_url') ? localStorage.getItem('after_logout_redirect_to_specific_url') : "";
@Injectable()
export class AutoLogoutService {
  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }
  tokenFromUI:string = "TYASuite!#!TYASuite!TYASuite!#!@";

  private onlineEventListener: any = null;

  constructor(private router: Router, public _localStorageService: LocalStorageService,    private toasterService: ToasterService,
    ) {
    // this.check();
    // this.initListener();
    // this.initInterval();
    
    // Setup online event listener to check for logout when user comes back online
    this.onlineEventListener = () => {
      // User came back online - immediately check if they should be logged out
      this.check();
    };
    window.addEventListener('online', this.onlineEventListener);
  }
  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;
    
    // Only logout if user is online
    // If user is offline, don't logout - wait until they come back online
    if (!navigator.onLine && isTimeout) {
      // User is offline and timeout occurred - don't logout yet
      // Will check again when they come back online
      return;
    }
    
    let logout_url=this.get('after_logout_redirect_to_specific_url',localStorage.getItem('after_logout_redirect_to_specific_url'))
    if(!this.validURL(logout_url) && isTimeout){
      // this.toasterService.pop("error","Error","Invalid URL")
      localStorage.clear();
      this.deleteAllCookies();
      this.router.navigate(['/']);
    }
  else {
    if (isTimeout && window.location.hostname!=='localhost' && logout_url == "") {
      //localStorage.setItem(STORE_KEY,'');
      this.toasterService.pop("error","Error","Your Session Timedout")
      localStorage.clear();
      this.deleteAllCookies();
      this.router.navigate(['/']);
    }
    if(isTimeout && window.location.hostname!=='localhost' && logout_url != "") {
      this.toasterService.pop("error","Error","Your Session Timedout")
      window.location.href = logout_url
      localStorage.clear();
      this.deleteAllCookies();
    }
  }
  }
  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-][a-z\\d]))\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+])'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }
  isInt(n) {
    return Number(n) === n && n % 1 === 0;
  }
  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  convertNaN(value) {
    if (this.isFloat(value)) {
      value = parseFloat(value).toFixed(2) || 0
    }
    else {
      value = value || 0
    }
    if (isNaN(value)) {
      value = 0;
    }
    let t = value || 0
    return t;
  }
  deleteAllCookies() {
    var cookies = document.cookie.split(";");
    if(cookies.length>0)
    {
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if(name!='accessrem')
        {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }
  }
}
set(value,key?:string)
{
  // console.log(value);
  // console.log(key);
// try{
//   if(localStorage.getItem('is_enc_on')=='MQ=='||key=='is_enc_on'||key=='is_login_psw')
//   // if(localStorage.getItem('is_enc_on')=='MQ==')
//   {
//     return btoa(value);
//   }
//   else
//   {
//     return value
//   }
// }
// catch(e)
// {
// return value
// }
let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
try{
   if(localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='||key=='is_enc_on'||key=='is_login_psw')
   {
    return CryptoJS.AES.encrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString();
   }
  }
   catch(e)
   {
     console.log(e.name);
     console.log(e.message);
return value
   }

}
get(key,value,is_cookie?:string)
{
//   try {
//   if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && localStorage.getItem('is_enc_on')=='MQ==')
//   {
//     // console.log('hey3');

//     return (atob(value)!=''&&atob(value)!=undefined&&atob(value)!=null)?(this.isJSON(atob(value))?JSON.parse(atob(value)):atob(value)):value;

//   }
//   else
//   {
//     return (this.isJSON(value)?JSON.parse(value):value);
//   }
// }
// catch(e)
// {
//   console.error('enc/dec logout key'+key,'value='+value)
//   window.localStorage.clear();
//   window.location.href=window.location.origin+"/#/login"
// }
let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
try {
  if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && (localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='&&is_cookie!='1'))
  {
    let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
    return this.isJSON(dec)?JSON.parse(dec):dec;
  }
  if(is_cookie=='1')
  {
    //console.log('is_cookie='+is_cookie+'key='+key)
    let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
    return this.isJSON(dec)?JSON.parse(dec):dec;
  }
  }
  catch(e)
  {
    console.error('enc/dec logout key'+key,'value='+value)
      window.localStorage.clear();
      window.sessionStorage.clear()
      window.location.href=window.location.origin+"/#/login"
  }

}
isJSON(str) {
  try {
      return (JSON.parse(str));
  } catch (e) {
      return false;
  }
}
}




// WEBPACK FOOTER //
// /codebuild/output/src2657079836/src/src/app/shared/services/auto-logout.service.ts